export { palette } from './colors';
export type { ColorPair, PaletteKey } from './colors';
export { ASSET_DISPLAY_STATES, stateChips } from './states';
export type { AssetDisplayState, StateChipToken } from './states';

/** Supported UI languages. `zh` is Simplified Chinese (mobile maps it to the `zh-Hans` locale). */
export const LANGUAGES = ['en', 'ms', 'zh'] as const;
export type Language = (typeof LANGUAGES)[number];
